"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.Warning = void 0;
var _react = _interopRequireDefault(require("react"));
var _uiTheme = require("@kyruus/ui-theme");
var _Warning = _interopRequireDefault(require("@kyruus/react-ikons/Warning"));
var _tooltip = require("@kyruus/tooltip");
var _styles = require("../../styles");
var _styles2 = require("./styles");
const Warning = _ref => {
  let {
    bookingWarning = /*#__PURE__*/_react.default.createElement("p", null, "Information is Missing from your Patient to Book an Appointment")
  } = _ref;
  const iconSize = (0, _uiTheme.fromTheme)('font_size_heading_3')({});
  const iconColor = (0, _uiTheme.fromTheme)('color_warning')({});
  return /*#__PURE__*/_react.default.createElement(_styles.ActionsWarning, null, /*#__PURE__*/_react.default.createElement(_styles2.WarningToolTip, null, /*#__PURE__*/_react.default.createElement(_tooltip.Tooltip, {
    title: bookingWarning,
    size: iconSize,
    color: iconColor,
    role: "alert"
  }, /*#__PURE__*/_react.default.createElement("span", null, /*#__PURE__*/_react.default.createElement(_Warning.default, {
    size: iconSize,
    color: iconColor
  })))), /*#__PURE__*/_react.default.createElement(_styles2.WarningBanner, {
    type: "warning",
    icon: "!"
  }, bookingWarning));
};
exports.Warning = Warning;
Warning.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Warning",
  "props": {
    "bookingWarning": {
      "defaultValue": {
        "value": "<p>Information is Missing from your Patient to Book an Appointment</p>",
        "computed": false
      },
      "required": false
    }
  }
};